import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Col, Row, Form, InputGroup, Container, Button, FormControl } from "react-bootstrap";
import { prepareGuaranteeLetterApi } from '../../services/api';
import { injectIntl } from "react-intl";
import './style.scss';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import PrepareLetter from "./prepare-letter";

const FormLetter = () => {
    const [form, setForm] = useState({
        serialNo: '',
        refNo: ''
    });
    useEffect(() => {
        let ckeditor = document.createElement("script");
        ckeditor.src = "ckeditor4/ckeditor.js";
        document.head.appendChild(ckeditor);
       
        ckeditor = document.createElement("script");
        ckeditor.src = "ckeditor4/assets/js/jquery.min.js";
        document.head.appendChild(ckeditor);
       
        ckeditor = document.createElement("script");
        ckeditor.src = "ckeditor4/assets/js/nouislider.min.js";
        document.head.appendChild(ckeditor);

        ckeditor = document.createElement("link");
        ckeditor.href = "ckeditor4/assets/css/nouislider.css";
        ckeditor.rel = "stylesheet";
        document.head.appendChild(ckeditor);



        document.title = "Soạn thư bảo lãnh";
    }, []);
    const [prepareLetter, setPrepareLetter] = useState(false);
    const [errorSerialNo, setErrorSerialNo] = useState('');
    const [errorFefNo, setErrorFefNo] = useState('');
    const [errorData, setErrorData] = useState(false);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const handleClose = () => setShow(false);
    const back = () => {
        handleClose();
        setErrorSerialNo('');
        setErrorFefNo('');
        setPrepareLetter(false);
    }
    const handleInput = (e) => {
        const name = e.target.name;
        let value = null;
        if (name == 'refNo' || name == 'serialNo') {
            value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
        }
        setForm({ ...form, [name]: value })
    }
    const validateData = () => {
        setErrorSerialNo('');
        setErrorFefNo('');
        let status = true;
        if (form.serialNo == '') {
            setErrorSerialNo("Vui lòng nhập số phôi");
            status = false;
        } else if (form.serialNo.length > 50 || (!/[0-9]/.test(form.serialNo))) {
            setErrorSerialNo("Vui lòng nhập đúng định dạng");
            status = false;
        }
        if (form.refNo == '') {
            setErrorFefNo("Vui lòng nhập số tham chiếu");
            status = false;
        } else if (form.refNo.length > 50 || (!/^[a-zA-Z0-9]*$/.test(form.refNo))) {
            setErrorFefNo("Vui lòng nhập đúng định dạng");
            status = false;
        }
        return status;
    }
    const getBankGuarentee = () => {
        const status = validateData();
        if (status) {
            const data = {
                serialNo: 'BL' + form.serialNo,
                letterGuarNo: form.refNo.toUpperCase()
            }
            setLoading(true);
            prepareGuaranteeLetterApi(data).then(res => {
                if (res.status == 200 && res.data) {
                    setLoading(false);
                    if (res.data.content.countLetter == 0) {
                        setShow(true);
                    } else {
                        setPrepareLetter(true);
                    }
                } else {
                    setLoading(false);
                    toast.error("Đã có lỗi xảy ra.Xin vui lòng thử lại!", 'Lỗi');
                }
            })
        }

    }
    const keepContinue = () => {
        if (form.serialNo != '' && form.refNo != '') {
            setPrepareLetter(true);
        }
    }

    return (
        <React.Fragment>
            {
                !prepareLetter ?
                    <Container className="py-5">
                        <ToastContainer />
                        {loading && <LoadingSpinner />}
                        <Row className="justify-content-center">
                            <Col xl={6} lg={8} md={10}>
                                <div className="form-letter p-5 bg-white">
                                    <h6 className="text-shb">NHẬP LIỆU THÔNG TIN</h6>
                                    <Form.Group className="mt-4">
                                        <Form.Label>Số phôi/serial number</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text id="basic-addon1">BL</InputGroup.Text>
                                            <FormControl id="basic-url" aria-describedby="basic-addon3" placeholder="xxxxxx" maxLength={50}
                                                name="serialNo" onKeyPress={(event) => {
                                                    if (!/[a-zA-Z0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} value={form.serialNo} onChange={(e) => handleInput(e)} />
                                        </InputGroup>
                                        <small className="text-danger">{errorSerialNo != 'true' ? errorSerialNo : ''}</small>
                                    </Form.Group>
                                    <Form.Group className="mt-4">
                                        <Form.Label>Số tham chiếu của cam kết bảo lãnh/ Reference Number</Form.Label>
                                        <FormControl id="basic-url" name="refNo" aria-describedby="basic-addon3" value={form.refNo}
                                            onKeyPress={(event) => {
                                                if (!/^[a-zA-Z0-9]*$/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            maxLength={50} onChange={(e) => handleInput(e)} />
                                        <small className="text-danger">{errorFefNo != 'true' ? errorFefNo : ''}</small>
                                    </Form.Group>
                                    <Form.Group className="mt-5">
                                        <Row className="justify-content-center">
                                            <Col md={5}>
                                                <div className="text-center">
                                                    <Button className="bg-shb btn-shb" onClick={getBankGuarentee}>Soạn thư</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </div>
                            </Col>
                        </Row>
                        <Modal show={show} onHide={handleClose} centered>
                            <Modal.Body className="text-center">
                                Thông tin bạn nhập chưa khớp trên hệ thống Core,<br />bạn có muốn tiếp tục hay không ?
                            </Modal.Body>
                            <Modal.Footer className="justify-content-center">
                                <button className="btn btn-shb" onClick={keepContinue}>
                                    Tiếp tục
                                </button>
                                <button className="btn btn-shb-outline" onClick={handleClose}>
                                    Đóng
                                </button>
                            </Modal.Footer>
                        </Modal>
                    </Container>
                    : <PrepareLetter serialNo={form.serialNo} refNo={form.refNo.toUpperCase()} back={back} />
            }
        </React.Fragment>
    );
}
export default injectIntl(FormLetter);